import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { CommonSelectInputProp } from "../../../../Type/CommonComponant";

const CommonSelectInput = ({label,inputClass, span,multiple}:CommonSelectInputProp) => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{label}</Label>
          <Input type="select" className={`digits ${inputClass}`} multiple={multiple}>
            {span.map((item:any, index:any) => (
              <option key={index}>{item}</option>
            ))}
          </Input>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default CommonSelectInput;
